import RestaurantIcon from '@mui/icons-material/Restaurant';
import { SvgIconProps } from '@mui/material';
import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import React from 'react';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';

export class ATLunchBenefitMetadataExtension extends BenefitMetadataExtensionInterface {
  benefitId: BenefitDTOBenefitEnum = BenefitDTOBenefitEnum.AtLunch;

  get Icon(): React.ComponentType<SvgIconProps> {
    return RestaurantIcon;
  }
}
